import React from 'react';

import appSettings from '../../config/settings';
import { FormattedMessage } from '../../util/reactIntl';

import { LayoutSingleColumn } from '../../components';
import css from './MaintenanceMode.module.css';

// MaintenanceMode component is shown when mandatory app-wide configurations are not found from assets.
// Note 1: this microcopy/translation does not come from translation file.
//         It needs to be something that is not part of fetched assets but built-in text
// Note 2: In the LandingPage directory, there's a similar content (FallbackPage.js).
const MaintenanceMode = props => {
  const isDev = appSettings.dev;
  return (
    <LayoutSingleColumn
      mainColumnClassName={css.layoutWrapperMain}
      topbar={
        <div className={css.header} title="Maintenance mode">
          <div className={css.logo}>
            <span className={css.emblem}>P</span>
            <span className={css.wordmark}>
              <span className={css.wmThe}>THE</span>
              <span className={css.wmPremier}>PREMIER</span>
              <span className={css.wmHorse}>HORSE</span>
            </span>
          </div>
        </div>
      }
      footer={null}
    >
      <section id="content" className={css.root}>
        <div className={css.content}>
          <p className={css.eyebrow}>
            <FormattedMessage id="MaintenanceMode.eyebrow" defaultMessage="Scheduled maintenance" />
          </p>
          <h2 className={css.heading}>
            <FormattedMessage id="MaintenanceMode.title" defaultMessage="We'll be" />
            <em className={css.headingEm}>
              <FormattedMessage id="MaintenanceMode.titleHighlight" defaultMessage="right back." />
            </em>
          </h2>
          <div className={css.goldRule} />
          <p className={css.lead}>
            <FormattedMessage
              id="MaintenanceMode.info"
              defaultMessage="The Premier Horse is down for a short tune-up in the barn. Nothing's wrong — we'll be back up and running shortly. Thanks for your patience."
            />
          </p>
          {isDev ? (
            <>
              <p>
                Check that all the configuration assets are added to your marketplace environment
                through the Marketplace Console.
              </p>
              <p>Check also browser's developer tools for printed errors.</p>
            </>
          ) : (
            <p className={css.eta}>
              <FormattedMessage
                id="MaintenanceMode.howToProceed"
                defaultMessage="Expected back · within the hour"
              />
            </p>
          )}
        </div>
      </section>
    </LayoutSingleColumn>
  );
};

export default MaintenanceMode;
